module.exports = __webpack_public_path__ + "img/20180815_151538_168.81f74162.jpg";